// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"61":"4787c8d023d1a484","104":"81fd8bb182af9896","774":"50dba18d3206131a","975":"81e3f06d4982aa9e","981":"d57106c02162160c"}[chunkId] + ".js";
};